import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {
  @Input() inputSearchValue;
  @Input() isVisibleSearchIcon = true;
  @Output() inputSearchValueEmit:EventEmitter<string> = new EventEmitter();
  @Output() inputActionIconClick:EventEmitter<string> = new EventEmitter();

  change(inputSearchValue:string){
    this.debouncedChange(inputSearchValue);
  }

  private debouncedChange = (() => {
    let timer: any;
    return (inputSearchValue: string) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.inputSearchValueEmit.emit(inputSearchValue);
      }, 500);
    };
  })();

}
